import { useEffect } from 'react';

// Injects a JSON-LD structured-data script into <head> for rich results / better SEO.
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => { const e = document.getElementById(scriptId); if (e) e.remove(); };
  }, [id, data]);
  return null;
};

export const SITE_URL = 'https://bluecactus.digital';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Blue Cactus Digital',
  url: SITE_URL,
  logo: 'https://customer-assets.emergentagent.com/job_0b608c3c-f868-434e-b1aa-578790eaab8e/artifacts/o5o9ncsr_blue%20cactus%20logo%20teal%20rgb.png',
  description: 'Specialist digital marketing agency for health and social care, charities and care technology.',
  areaServed: 'GB',
  sameAs: [
    'https://www.linkedin.com/company/blue-cactus-digital',
    'https://www.instagram.com/bluecactusdigital',
    'https://www.facebook.com/bluecactusdigital',
  ],
};

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});

export default JsonLd;
